import React from 'react';
import { motion } from 'framer-motion';
interface BeamsProps {
  className?: string;
  count?: number;
  color?: string;
}
export function Beams({
  className = '',
  count = 5,
  color = 'rgba(26,143,212,0.4)'
}: BeamsProps) {
  return <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} data-id="element-206">
      {Array.from({
      length: count
    }).map((_, i) => {
      const delay = i * 1.5;
      const left = 10 + i * 18;
      const width = 1 + i % 3 * 0.5;
      return <motion.div key={i} className="absolute top-0 bottom-0" style={{
        left: `${left}%`,
        width: `${width}px`,
        background: `linear-gradient(180deg, transparent 0%, ${color} 50%, transparent 100%)`,
        filter: 'blur(1px)',
        transform: 'skewX(-15deg)'
      }} initial={{
        y: '-100%',
        opacity: 0
      }} animate={{
        y: '100%',
        opacity: [0, 1, 1, 0]
      }} transition={{
        duration: 4 + i % 3,
        repeat: Infinity,
        delay,
        ease: 'easeInOut'
      }} data-id="element-207" />;
    })}
    </div>;
}